import PropTypes from "prop-types";
import React from "react";
import Config from "config";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import {
  fetchDerniersDocsRequest,
  fetchDocumentationRequest,
  fetchListRequest,
  fetchSasDataRequest,
  fetchDossierCompletRequest,
  fetchMontantInvestRequest,
  fetchDossierRequest,
  fetchSyntheseRequest,
  fetchReservRequest,
  fetchSyntheseAnneeRequest,
} from "../../store/actions";
import { useEffect, useState } from "react";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
import SubscriptionsComponent from "./DerniereSouscriptions";
import DossierV from "./DossierValide";
import Sas from "./Sas";
import DossierComplet from "./DossierComplet";
import MontantInvest from "./MontantInvest";
import SyntheseAnnuelle from "./SyntheseAnnuelle";
import Synthese from "./SyntheseAnnee";
import Reserv from "./DerniereReserv";
import Spinners from "components/Common/Spinner";
import Documentation from "./Documentation";
import Declaration from "./Declaration";
import DeclarationN from "./DeclarationN";
import SouscriptionsEnCours from "./SouscriptionsEnCours";

const Dashboard = (props) => {
  //meta title
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  document.title = "Dashboard | DOM COM INVEST";
  const dispatch = useDispatch();
  const history = useNavigate();
  // const token = useSelector((state) => state.Login.token); avec Redux
  const token = localStorage.getItem("auth_token");
  const redirectToLoginPage = useSelector(
    (state) => state.LastSubscription.redirectToLoginPage
  );
  // On recupere les données des dernières souscription
  const lastSubData = useSelector(
    (state) => state.LastSubscription.lastSubData
  );
  // On recupere les données des Sas
  const sasData = useSelector((state) => state.Sas.sasData);
  // On recupere les données des dossiers complets
  const dossierCompletData = useSelector(
    (state) => state.DossierComplet.dossierComplet
  );
  // On recupere les données des montant investissements
  const montantInvestData = useSelector(
    (state) => state.MontantInvest.montantInvestData
  );
  // On recupere les données des dossiers valides
  const dossierValideData = useSelector(
    (state) => state.DossierValide.dossierData
  );
  // On recupere les données des synthese annuelles
  const syntheseData = useSelector(
    (state) => state.SyntheseAnnuelle.syntheseData
  );
  // On recupere les données des reservations
  const reservationData = useSelector(
    (state) => state.DerniereReser.reservData
  );
  // On recupere les données de documentation reglementaire
  const documentationReglementaire = useSelector(
    (state) => state.DocumentationReglementaire.DocumentationData
  );
  // On recupere les données des derniers documents
  const DerniersDocs = useSelector(
    (state) => state.DerniersDocs.derniersDocsData
  );
  // On recupere les données de la synthese de l'année en cours
  const SyntheseAnnee = useSelector(
    (state) => state.SyntheseAnnee.syntheseAnneeData
  );

  const error = useSelector((state) => state.LastSubscription.error);
  const [loading, setLoading] = useState(true);
  const [declarationData, setDeclarationData] = useState("");
  const [declarationNData, setDeclarationNData] = useState("");
  const [souscriptionsEnCoursData, setSouscriptionsEnCoursData] = useState("");

  const [selectedAnnee, setSelectedAnnee] = useState();
  const [selectedAnneeN, setSelectedAnneeN] = useState();
  const [annee, setAnnee] = useState(selectedAnnee);
  const [anneeN, setAnneeN] = useState(selectedAnneeN);
  const getDeclarationData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fdashboards/widget_ma_decalaration_annee_n`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      // if (!response.ok) {
      //   localStorage.removeItem("auth_token");
      //   localStorage.removeItem("authUser");
      //   localStorage.removeItem("sideBar");
      //   history(`${backUrl}/login`);
      //   window.location.reload(false);
      //   throw new Error(`Request failed with status: ${response.status}`);
      // }

      const Data = await response.json();
      setDeclarationData(Data);
      setSelectedAnnee(Data?.selected_filter);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const getDeclarationNData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fdashboards/widget_synthese_annuelle_n`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const Data = await response.json();
      setDeclarationNData(Data);
      setSelectedAnneeN(Data?.selected_filter);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const getSouscriptionsEnCoursData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fdashboards/widget_souscriptions_en_cours`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const Data = await response.json();
      setSouscriptionsEnCoursData(Data);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const handleDeclarationDataChange = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fdashboards/widget_ma_decalaration_annee_n?annee_id=${annee?.value}}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      // if (!response.ok) {
      //   localStorage.removeItem("auth_token");
      //   localStorage.removeItem("authUser");
      //   localStorage.removeItem("sideBar");
      //   history(`${backUrl}/login`);
      //   window.location.reload(false);
      //   throw new Error(`Request failed with status: ${response.status}`);
      // }

      const Data = await response.json();
      setDeclarationData(Data);
      setSelectedAnnee(Data?.selected_filter);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const handleDeclarationNDataChange = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fdashboards/widget_synthese_annuelle_n?annee_id=${anneeN?.value}}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      // if (!response.ok) {
      //   localStorage.removeItem("auth_token");
      //   localStorage.removeItem("authUser");
      //   localStorage.removeItem("sideBar");
      //   history(`${backUrl}/login`);
      //   window.location.reload(false);
      //   throw new Error(`Request failed with status: ${response.status}`);
      // }

      const Data = await response.json();
      setDeclarationNData(Data);
      setSelectedAnneeN(Data?.selected_filter);
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    if (token) {
      dispatch(fetchDocumentationRequest(token));
      dispatch(fetchListRequest(token));
      dispatch(fetchSasDataRequest(token));
      dispatch(fetchDossierCompletRequest(token));
      dispatch(fetchMontantInvestRequest(token));
      dispatch(fetchDossierRequest(token));
      dispatch(fetchSyntheseRequest(token));
      dispatch(fetchReservRequest(token));
      dispatch(fetchDerniersDocsRequest(token));
      dispatch(fetchSyntheseAnneeRequest(token));
      getDeclarationData();
      getDeclarationNData();
      getSouscriptionsEnCoursData();
    }
  }, [dispatch, token]);
  useEffect(() => {
    if (redirectToLoginPage) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("authUser");
      localStorage.removeItem("sideBar");
      history(`${backUrl}/login`);
      window.location.reload(false);
    }
  }, [redirectToLoginPage, history]);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  useEffect(() => {
    if (annee !== undefined) {
      handleDeclarationDataChange();
    }
  }, [annee]);
  useEffect(() => {
    if (anneeN !== undefined) {
      handleDeclarationNDataChange();
    }
  }, [anneeN]);
  const renderAnneeOptions = () => {
    return [
      {
        options: declarationData.filtres.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  const renderAnneeNOptions = () => {
    return [
      {
        options: declarationNData.filtres.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="mt-3">
            {error && <p>Error: {error}</p>}
            {!loading ? (
              <>
                {dossierValideData.allowed ? (
                  <>
                    <Col md="6">
                      <SubscriptionsComponent listData={lastSubData} />
                      <DossierV listData={dossierValideData} />
                    </Col>
                  </>
                ) : null}
                {sasData.allowed ? (
                  <>
                    <Col md="6">
                      <Sas listData={sasData} />
                    </Col>
                  </>
                ) : null}
                {dossierCompletData.allowed ? (
                  <>
                    <Col md="6">
                      <DossierComplet listData={dossierCompletData} />
                    </Col>
                  </>
                ) : null}

                {montantInvestData.allowed ? (
                  <>
                    <Col md="6">
                      <MontantInvest listData={montantInvestData} />
                    </Col>
                  </>
                ) : null}
                {souscriptionsEnCoursData.allowed ? (
                  <>
                    <Col md="6">
                      <SouscriptionsEnCours
                        listData={souscriptionsEnCoursData}
                      />
                    </Col>
                  </>
                ) : null}
                <Col md="6">
                  {SyntheseAnnee.allowed ? (
                    <>
                      <Synthese listData={SyntheseAnnee} />
                    </>
                    ) : null
                  }
                  {documentationReglementaire.allowed ? (
                    <>
                      <Documentation listData={documentationReglementaire} />
                    </>
                  ) : null}
                </Col> 
                
                {DerniersDocs.allowed ? (
                  <>
                    <Col md="6">
                      <Documentation listData={DerniersDocs} />
                    </Col>
                  </>
                ) : null}
                {syntheseData.allowed ? (
                  <>
                    <Col md="12">
                      <SyntheseAnnuelle listData={syntheseData} />
                    </Col>
                  </>
                ) : null}

                {reservationData.allowed ? (
                  <>
                    <Col md="12">
                      <Reserv listData={reservationData} />
                    </Col>
                  </>
                ) : null}
                {declarationData.allowed ? (
                  <>
                    <Col md="12">
                      <Declaration
                        title={declarationData.title}
                        data={declarationData.data}
                        data_files={declarationData.data_files}
                        annee={selectedAnnee}
                        setAnnee={setAnnee}
                        filtre={renderAnneeOptions()}
                      />
                    </Col>
                  </>
                ) : null}
                {declarationNData.allowed ? (
                  <>
                    <Col md="12">
                      <DeclarationN
                        title={declarationNData.title}
                        data={declarationNData.data}
                        data_files={declarationNData.data_files}
                        annee={selectedAnneeN}
                        setAnnee={setAnneeN}
                        filtre={renderAnneeNOptions()}
                      />
                    </Col>
                  </>
                ) : null}
              </>
            ) : (
              <Col>
                <Spinners setLoading={setLoading} />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
  history: PropTypes.object,
};

export default withTranslation()(Dashboard);
